type Primitive = string | number | bigint | boolean | symbol | undefined | null;

export const isPrimitive = (value: unknown): value is Primitive => {
    if (value === null) {
        return true;
    }

    if (typeof value === "object" || typeof value === "function") {
        return false;
    }

    return true;
};
